import React, { useState } from "react";
// import Navbar from "../components/Nav.jsx";
import gql from 'graphql-tag';
import { useApolloClient } from '@apollo/react-hooks';
// import { UserStates } from '../../src/utils/react-redux/actions/user_states';
import { UserStates } from '../../utils/react-redux/actions/user_states';
import { useSelector, useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSetAccess } from "state/hooks.js";
import { PACKAGE_TYPE } from "utils/constantenums.js";

const AUTH_USER = gql`
    query login($email: String! , $password: String! ){
        clientLogin(email:$email, password:$password){
            access_token
            user_info {
              user_id
              email
              package_type
              grant_at
              is_terms_condition
              is_ppt_enabled
              group_id {
                group_id
                name
                description
              }
            }
        }
    }
`;
const GET_REGIONS = gql`
  query GetRegionsByUserGroup($group_id : Int!){
    getRegionsByUserGroup(group_id : $group_id ){
        name
        region_id
        exchange_rate
        currency_symbol
      }
      
  }
`;
const Login = () => {
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const emailRegex = new RegExp("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$");
  const [Loading, setLoading] = useState(false);
  const [loadpage, setLoadPage] = useState(false);
  const [email, setEmail] = useState(''); // '' is the initial state for email value
  const [password, setPassword] = useState(''); // '' is the initial state for password value
  const [showExpiredUserMessage, setShowExpiresUserMessage] = useState(false)
  const client = useApolloClient();
  const isLogged = useSelector((state) => state.signIn)
  const dispatch = useDispatch()
  let [regionNamesWithCurrency] = useState([]);
  const { setAccessState } = useSetAccess()

  const validate = () => {
    let passwordError = "";
    let emailError = "";
    if (email.length === 0) {
      emailError = "Email is required"
    } else if (emailRegex.test(email) !== true) {
      emailError = "Email Is Invalid"
    } else {
      emailError = "";
    }
    if (password.length === 0) {
      passwordError = "Password is required";
    } else if (password.length < 8 || password.length > 30) {
      passwordError = "Length must be between[8-30]"
    } else {
      passwordError = "";
    }

    if (emailError || passwordError) {
      setEmailError(emailError);
      setPasswordError(passwordError);
      return false;
    } else {
      return true;
    }
  }
  //Login user 
  const LoginUser = async () => {
    const isValid = validate();
    if (isValid) {
      setLoading(true);
      setEmailError("");
      setPasswordError("");
      await client.query({
        query: AUTH_USER,
        variables: { email, password }
      }).then(res => {

        const userInfo = res.data.clientLogin.user_info;
        const isPptEnabled = userInfo.is_ppt_enabled;
        // Cache basic account details for report export modal auto-fill
        sessionStorage.setItem('user_email', userInfo.email || email || '');
        if (!sessionStorage.getItem('user_name')) {
          const derivedName = (userInfo.email || email || '')
            .split('@')[0]
            .replace(/[._-]+/g, ' ')
            .replace(/\b\w/g, (c) => c.toUpperCase())
            .trim();
          sessionStorage.setItem('user_name', derivedName);
        }

        // debugger
        if (res.data.clientLogin.user_info.package_type === PACKAGE_TYPE.PREMIUM) {
          setAccessState(true)
          sessionStorage.setItem('allow', 'flexible')
        } else {
          setAccessState(true)
          sessionStorage.setItem('allow', 'fix')
        }
        sessionStorage.setItem('is_ppt_enabled', String(isPptEnabled));
        toast.success('Login Successfully')
        sessionStorage.setItem('access_token', res.data.clientLogin.access_token);
        sessionStorage.setItem('accept-agreement', res.data.clientLogin.user_info.is_terms_condition);
        sessionStorage.setItem('user_id', res.data.clientLogin.user_info.user_id);
        //get regions
        client.query({
          query: GET_REGIONS,
          variables: { group_id: res.data.clientLogin.user_info.group_id.group_id },
          fetchPolicy: 'no-cache'
        }).then(res => {
          res.data.getRegionsByUserGroup.map((temp) => {
            regionNamesWithCurrency.push(temp.name + ' (' + temp.currency_symbol + ')')
            return temp.name;
          });
          const uniqueNames = Array.from(new Set(regionNamesWithCurrency));
          sessionStorage.setItem("CurrencyRegions", JSON.stringify(uniqueNames));
          sessionStorage.setItem("all_currencies", JSON.stringify(res.data.getRegionsByUserGroup));
          setLoadPage(true);
          setLoading(false);

        }).catch(error => {
          // toast.error(error.graphQLErrors[0].messasge.message)
        });

        setEmail('');
        setPassword('');
        sessionStorage.setItem('group_id', res.data.clientLogin.user_info.group_id.group_id);
        if (isLogged === false) {
          dispatch(UserStates())
        }
        sessionStorage.setItem('signInstatus', 'true');
        sessionStorage.setItem('signIn', 'true');

      }).catch(error => {
        setLoading(false);
        toast.error(error?.graphQLErrors[0]?.extensions?.exception?.response?.error)
        if (error?.graphQLErrors[0]?.extensions?.exception?.response?.status === 401) {
          setShowExpiresUserMessage(true)
        }
        if (error?.graphQLErrors[0]?.extensions?.exception?.response?.error === 'Incorrect Password') {
          setPassword('');
        } else {
          setEmail('');
          setPassword('');
        }
      });
    }

  }
  const nextKey = () => {
    document.getElementById('pass-value').focus();
  }
  React.useEffect(() => {
    if (loadpage) {
      window.location.href = `/region-select`
    }
  }, [loadpage]);

  return (
    <React.Fragment>
      <ToastContainer />
      {/* <Navbar /> */}
      <div className="p-24">
        <div className="row fill justify-content-start align-items-start mt-120" >
          <div className="col-lg-6 col-md-6 d-flex justify-content-end">
            <div className="d-flex flex-column justify-content-start align-items-center  ">
              <div className="d-flex flex-column align-items-center gap-24 login-hero">
                <div className="login-hero-image-wrap">
                  <img
                    src="/assets/loginImage.jpeg"
                    alt="login"
                    className="login-hero-image"
                  />
                </div>
                {/* <div className="text-center  px-40">
                  <p className="font-32 font-semi-bold mb-12">
                    Lorem ipsum dolor sit amet
                  </p>
                  <p className="font-16 font-normal">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.{" "}
                  </p>
                </div>{" "} */}
              </div>
              <img
              className="mt-24"
                  src="/assets/login-logo.png"
                  alt="login"
                />
            </div>
          </div>
          <div className="col-md-6 login-container">
              <div className="login-form">
              <div>
              <p className="font-semi-bold font-32">Login to your account</p>
              <p className="mt-12">Please fill in your credentials below to login.</p>
              </div>
              <div>
                <p className="login-text">E-mail</p>
                <div className="text-box1">
                  <input
                    type="email"
                    id="email-value"
                    className="login-input "
                    value={email}
                    placeholder="Enter Here"
                    onChange={(evt) => {
                      setEmailError("");
                      setEmail(evt.target.value);
                    }}
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        nextKey();
                      }
                    }}
                  />
                </div>
                <p className="errorMessage float-left">{emailError}</p>
                <p className="login-text">Password</p>
                <div className="text-box1">
                  <input
                    type="password"
                    id="pass-value"
                    className="login-input"
                    placeholder="Enter Here"

                    value={password}
                    onChange={(evt) => {
                      setPasswordError("");
                      setPassword(evt.target.value);
                    }}
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        LoginUser();
                      }
                    }}
                  />
                </div>
                {showExpiredUserMessage && (
                  <div className="d-flex flex-column">
                    <span className="errorMessage float-left disclaimer mt-2">
                      We are happy you’ve enjoyed using the EOS Cost & Carbon
                      Calculator.
                    </span>
                    <span className="errorMessage float-left disclaimer mt-2">
                      Your access has expired.{" "}
                      <a
                        href="https://store.eos.info/products/eos-cost-carbon-calculator?variant=44453425512714?utm_source=CCC_Tool"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="sign-up-text"
                      >
                        Upgrade or renew now{" "}
                      </a>{" "}
                      to Premium to keep enjoying access to all the features and
                      benefits of the EOS Cost & Carbon Calculator
                    </span>

                    <p className="mt-4 ">With Premium, you'll get:</p>
                    <ul>
                      <li>All system and material combinations</li>
                      <li>
                        Visual analytics, scenario analysis, and report generation
                      </li>
                      <li>Customized cases for customer pricing</li>
                    </ul>
                    <p className="mt-2">
                      Visit the{" "}
                      <a
                        href="https://store.eos.info/products/eos-cost-carbon-calculator?variant=44453425512714?utm_source=CCC_Tool"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="sign-up-text"
                      >
                        EOS Store
                      </a>{" "}
                      to purchase Premium Access for 1 year
                    </p>
                  </div>
                )}
                <span className="errorMessage float-left">{passwordError}</span>
                
                <button
                  className="button1"
                  onClick={LoginUser}
                  disabled={Boolean(Loading)}
                >
                  {Loading ? (
                    <>
                      <i class="fa fa-spinner fa-spin mr-2"></i>
                      <p>Loading</p>
                    </>
                  ) : (
                    <p>Login</p>
                  )}
                </button>
                <div className="subtext1">
                  <a href="/reset-password">Forgot Password?</a>
                </div>
                <div className="signUp-text  ">
                  <a
                    href="https://store.eos.info/products/eos-cost-carbon-calculator?variant=44453425512714?utm_source=CCC_Tool"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Don’t have an account please?{" "}
                    <strong className="font-weight-bold">Sign Up</strong>
                  </a>
                </div>
              </div>
              </div>
          </div>
          {/* <div className="col-lg-6 coverimage image1"></div> */}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Login;